<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9qWTV2/tc-custom/9781467456883.jpg?1708515321880" alt="This image is the cover for the book When Poets Pray"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">When Poets Pray
      </h1>
      <p class="bookDescription body article font2">
        <p><i>Two dozen select prayer poems to learn from and live with</i></p><p>Poetry and prayer are closely related. We often look to poets to give language to our deepest hopes, fears, losses—and prayers. Poets slow us down. They teach us to stop and go in before we go on. They play at the edges of mystery, holding a tension between line and sentence, between sense and reason, between the transcendent and the deeply, comfortingly familiar. <br/><br/><i>When Poets Pray</i> contains thoughtful meditations by Marilyn McEntyre on choice poems/prayers and poems about prayer. Her beautifully written reflections are contemplative exercises, not scholarly analyses, meant more as invitation than instruc¬tion. Here McEntyre shares gifts that she herself has received from poets who pray, or who reflect on prayer, believing that they have other gifts to offer readers seeking spiritual companionship along our pilgrim way. <br/><br/><b>POETS DISCUSSED IN THIS BOOK</b><br/><br/> Hildegard of Bingen <br/> Lucille Clifton <br/> Walter Chalmers Smith <br/> Robert Frost <br/> Wendell Berry <br/> Joy Harjo <br/> John Donne <br/> Gerard Manley Hopkins <br/> Said <br/> Marilyn McEntyre <br/> George Herbert<br/> Thomas Merton <br/> Denise Levertov <br/> Scott Cairns <br/> Mary Oliver <br/> Marin Sorescu <br/> T. S. Eliot <br/> Richard Wilbur <br/> Francisco X. Alarcon <br/> Anna Kamienska <br/> Michael Chitwood <br/> Psalm 139:1-12</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marilyn McEntyre
      </h2>
      
      <p class="authorDescription body article">&#160;<B>Marilyn McEntyre</B>&#160;is the award-winning author of several books on language and faith, including&#160;<I>Where the Eye Alights, Caring for Words in a Culture of Lies, Speaking Peace in a Climate of Conflict, When Poets Pray, Make a List, Word by Word</I>, and&#160;<I>What&#39;s in a Phrase? Pausing Where Scripture Gives You Pause</I>, winner of the 2015&#160;<I>Christianity Today</I>&#160;book award in spirituality.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3166862e